import { Outlet } from 'react-router-dom';

import { MainLayoutComponent } from '@src/core/routing/components/main-layout.component';
import { useContext } from 'react';
import { TokenProviderContext } from '@src/core/auth/components/token-provider.component';

export const LayoutWrapperComponent = () => {
  const { isFullyAuthenticated } = useContext(TokenProviderContext);

  if (isFullyAuthenticated) {
    return <MainLayoutComponent />;
  }

  return <Outlet />;
};
